import { Component } from '@angular/core';
import {BreadcrumbHeaderComponent} from '../../../LandingPage/NavigationMenu/page-headline/page-headline.component';
import {ParallaxSectionComponent} from '../parallax-section/parallax-section.component';
import {ColorScssService} from '../../../shared/service/color-scss.service';
import {CallToActionSectionComponent} from '../../FeaturePage/call-to-action-section/call-to-action-section.component';
import {AttentionInfoTextSectionComponent} from '../attention-info-text-section/attention-info-text-section.component';
import {ProContraPrallaxSectionComponent} from '../pro-contra-prallax-section/pro-contra-prallax-section.component';
import {UserMarktSegmentSectionComponent} from '../user-markt-segment-section/user-markt-segment-section.component';
import {CallToActionSection2Component} from '../call-to-action-section2/call-to-action-section2.component';
import {CardBannerOverviewSectionComponent} from '../card-banner-overview-section/card-banner-overview-section.component';

@Component({
  selector: 'app-emailkampange',
  standalone: true,
  imports: [
    BreadcrumbHeaderComponent,
    ParallaxSectionComponent,
    CallToActionSectionComponent,
    AttentionInfoTextSectionComponent,
    ProContraPrallaxSectionComponent,
    UserMarktSegmentSectionComponent,
    CallToActionSection2Component,
    CardBannerOverviewSectionComponent
  ],
  templateUrl: './emailkampange.component.html',
  styleUrl: './emailkampange.component.scss'
})
export class EmailkampangeComponent {

  constructor(private color: ColorScssService) {
    color.resetColorScheme()
  }

}
